import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

type Props = { value: any; onChange: (v: any) => void };
export default function BasicInfoStep({ value, onChange }: Props) {
  return (
    <div className="grid gap-4">
      <div>
        <label className="text-sm">Bot name</label>
        <Input value={value.name} onChange={(e)=>onChange({...value, name:e.target.value})} placeholder="e.g. Alex Creator Bot" />
      </div>
      <div>
        <label className="text-sm">Persona/Bio</label>
        <Textarea value={value.persona} onChange={(e)=>onChange({...value, persona:e.target.value})} placeholder="Tone, style, boundaries..." />
      </div>
      <div>
        <label className="text-sm">Greeting message</label>
        <Input value={value.greeting} onChange={(e)=>onChange({...value, greeting:e.target.value})} placeholder="Hey! I’m Alex—ask me anything ✨" />
      </div>
    </div>
  );
}
